export enum ActionType {
  SET_PRODUCT_API_ENABLED = 'SET_PRODUCT_API_ENABLED',
  SET_PREORDER_PERIOD = 'SET_PREORDER_PERIOD',
  SET_CURRENT_STATE = 'SET_CURRENT_STATE',
  CANCEL_CHANGES = 'CANCEL_CHANGES',
  ADD_REGION_AND_LOCALE_SET = 'ADD_REGION_AND_LOCALE_SET',
  TOGGLE_REGION_AND_LOCALE_SET_ENABLED = 'TOGGLE_REGION_AND_LOCALE_SET_ENABLED',
  SET_FORM_ERRORS = 'SET_FORM_ERRORS',
  SET_IS_SUBMITTING = 'SET_IS_SUBMITTING',
}

export type SetProductApiEnabledAction = {
  type: ActionType.SET_PRODUCT_API_ENABLED;
  payload: {
    productApiEnabled: boolean;
  };
};

export type SetPreorderPeriodAction = {
  type: ActionType.SET_PREORDER_PERIOD;
  payload: {
    preorderPeriod: string;
  };
};

export type SetCurrentStateAction = {
  type: ActionType.SET_CURRENT_STATE;
  payload: {
    currentState: FormState;
  };
};

export type CancelChangesAction = {
  type: ActionType.CANCEL_CHANGES;
};

export type AddRegionAndLocaleSetAction = {
  type: ActionType.ADD_REGION_AND_LOCALE_SET;
  payload: {
    regionAndLocaleSet: RegionAndLocaleSet;
  };
};

export type ToggleRegionAndLocaleSetEnabledAction = {
  type: ActionType.TOGGLE_REGION_AND_LOCALE_SET_ENABLED;
  payload: {
    regionAndLocaleSet: RegionAndLocaleSet;
  };
};

export type SetFormErrorsAction = {
  type: ActionType.SET_FORM_ERRORS;
  payload: {
    formErrors: Record<string, ValidatedErrors>;
  };
};

export type SetIsSubmittingAction = {
  type: ActionType.SET_IS_SUBMITTING;
  payload: {
    isSubmitting: boolean;
  };
};

export type Action =
  | SetProductApiEnabledAction
  | SetPreorderPeriodAction
  | SetCurrentStateAction
  | CancelChangesAction
  | AddRegionAndLocaleSetAction
  | ToggleRegionAndLocaleSetEnabledAction
  | SetFormErrorsAction
  | SetIsSubmittingAction;

export type RegionAndLocaleSet = {
  enabled: boolean;
  region: string;
  locale: string;

  // fields known after save
  isDefault?: boolean;
  _id?: string;
  id?: string;
};

export type Merchant = {
  productApiEnabled: boolean;
  preorderPeriod: string;
};

export type ValidatedErrors = { key: string; options: any };

export type FormState = {
  productApiEnabled: boolean;
  preorderPeriod: string;
  regionAndLocaleSets: RegionAndLocaleSet[];
};

export type State = {
  editingState: FormState;
  currentState: FormState;
  isSubmitting: boolean;
  formErrors: Record<string, ValidatedErrors>;
};
